export enum StateRestricted {
    AmmunitionShipping = 'ammunitionShipping'
}
